"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotOrderList = void 0;
const spot_1 = require("../types/binance/shared/spot");
const spot_2 = require("../types/binance/websockets/spot");
const spot_3 = require("../utils/dataMappers/spot");
const formatted_1 = require("../utils/eventFilters/formatted");
const shared_1 = require("./shared");
class SpotOrderList extends shared_1.OrderList {
    constructor(params) {
        super(params);
        this.update(Object.assign({}, params));
    }
    static load(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { fetchOrders, orders } = params;
            let ordersToInit = orders;
            if (typeof fetchOrders === 'function') {
                ordersToInit = yield fetchOrders();
            }
            return new SpotOrderList(Object.assign(Object.assign({}, params), { orders: ordersToInit || [] }));
        });
    }
    update(params) {
        const { orders, events } = params;
        const orderEvents = events ? formatted_1.eventFormattedFiltersMap[spot_2.EWsBinanceSpotEventsTypes.executionReport](events) : undefined;
        const eventsFiteredByTime = orderEvents === null || orderEvents === void 0 ? void 0 : orderEvents.filter(order => order.eventTime >= this.lastFetch).map(spot_3.sporOrderUpdateToSpotOrderMapper); // TODO: remove
        const ordersFilteredByTime = [...(orders || []), ...(eventsFiteredByTime || [])];
        for (let order of ordersFilteredByTime) {
            if (this.config.removeInactive) {
                if (![spot_1.ESpotOrderStatus.NEW, spot_1.ESpotOrderStatus.PARTIALLY_FILLED].includes(order.status))
                    this.orders.delete(order.orderId);
                else {
                    this.orders.set(order.orderId, order);
                }
            }
            else
                this.orders.set(order.orderId, order);
        }
    }
    fetchInitial() {
        return __awaiter(this, void 0, void 0, function* () {
            let ordersPromise;
            if (this.fetchOrders !== undefined)
                ordersPromise = yield this.fetchOrders();
            return {
                orders: ordersPromise || [],
            };
        });
    }
}
exports.SpotOrderList = SpotOrderList;
